module.exports = __webpack_public_path__ + "static/media/saviour.0e57c3c5.jpg";